import { cva } from 'class-variance-authority';

import { cn } from '@/helpers/utils';

function Empty({ className, ...props }) {
    return (
        <div
            data-slot='empty'
            className={cn(
                'flex w-full min-w-0 flex-1 flex-col items-center justify-center gap-4 rounded-lg border-dashed p-12 text-center text-balance',
                'animate-in fade-in-0 zoom-in-95 duration-300',
                className,
            )}
            {...props}
        />
    );
}

function EmptyHeader({ className, ...props }) {
    return (
        <div
            data-slot='empty-header'
            className={cn('flex max-w-sm flex-col items-center gap-2', className)}
            {...props}
        />
    );
}

const emptyMediaVariants = cva(
    'mb-2 flex shrink-0 items-center justify-center [&_svg]:pointer-events-none [&_svg]:shrink-0',
    {
        variants: {
            variant: {
                default: 'bg-transparent',
                icon: "flex size-12 shrink-0 items-center justify-center rounded-2xl bg-muted text-foreground ring-1 ring-foreground/5 [&_svg:not([class*='size-'])]:size-6",
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

function EmptyMedia({ className, variant = 'default', ...props }) {
    return (
        <div
            data-slot='empty-icon'
            data-variant={variant}
            className={cn(emptyMediaVariants({ variant, className }))}
            {...props}
        />
    );
}

function EmptyTitle({ className, ...props }) {
    return (
        <div
            data-slot='empty-title'
            className={cn('font-heading text-lg font-medium tracking-tight', className)}
            {...props}
        />
    );
}

function EmptyDescription({ className, ...props }) {
    return (
        <div
            data-slot='empty-description'
            className={cn(
                'text-sm/relaxed text-muted-foreground [&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:text-primary',
                className,
            )}
            {...props}
        />
    );
}

function EmptyContent({ className, ...props }) {
    return (
        <div
            data-slot='empty-content'
            className={cn(
                'flex w-full max-w-sm min-w-0 flex-col items-center gap-4 text-sm text-balance',
                className,
            )}
            {...props}
        />
    );
}

export { Empty, EmptyHeader, EmptyTitle, EmptyDescription, EmptyContent, EmptyMedia };
